import { FlagOutlined } from "@ant-design/icons";
import { ReactComponent as ShipIcon } from "../../../assets/svgIcon/menuIcon/Shipments.svg";
import { Plane } from "../../../assets/svgIcon/listView/Plane.jsx";
import { laneTransportModeForStatusLabel } from "../../../../shipment/constants/shipmentBoardLaneMode.js";

/**
 * Transport or milestone icon shown on shipment board column headers.
 */
export function BoardLaneModeIcon({ kind, statusLabel }) {
  if (kind === "milestone") {
    return <FlagOutlined className="boardLaneModeIcon milestone" aria-hidden />;
  }

  const mode = laneTransportModeForStatusLabel(statusLabel);
  if (mode === "ocean") {
    return <ShipIcon className="boardLaneModeIcon ocean" aria-hidden />;
  }
  if (mode === "air") {
    return <Plane className="boardLaneModeIcon air" size={22} />;
  }
  return null;
}
